import { useFetcher, useOutletContext, useParams, useSearchParams } from '@remix-run/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '~/components/Button';
import StatusInputs from '~/components/Forms/StatusInputs';

import type { OutletContext } from '~/interfaces/outlet_context';
import type { Publication } from '~/interfaces/publication';

import useToast from '~/hooks/useToast';

interface Props {
  publication: Publication;
  onUnsubscribe: (id: string) => void;
}

const Unsubscribe = ({ publication, onUnsubscribe }: Props) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const fetcher = useFetcher();
  const params = useParams();
  const { subscriberId } = params;
  const fetcherData = fetcher.data;
  const isSubmitting = fetcher.state === 'submitting';
  const { removeCookie, cookies } = useOutletContext<OutletContext>();
  // @ts-ignore
  const status = fetcherData?.toast?.status;

  useEffect(() => {
    // @ts-ignore
    if (fetcherData?.postUnsubscribeFormId) {
      // @ts-ignore
      onUnsubscribe(fetcherData?.postUnsubscribeFormId);
    }
    // @ts-ignore
  }, [onUnsubscribe, fetcherData?.postUnsubscribeFormId]);

  // @ts-ignore
  useToast(fetcherData?.toast);

  // Remove active upgrade cookie if the downgrade was successful
  useEffect(() => {
    if (status === 'success') {
      removeCookie('active_upgrade');
    }
  }, [status]);

  return (
    <fetcher.Form method="post" action="/unsubscribe">
      <input hidden name="subscriber_id" defaultValue={subscriberId} />
      <input hidden name="unsubscribe_form_id" defaultValue={publication.post_unsubscribe_form_id || ''} />
      {searchParams.has('post_id') && <input hidden name="post_id" defaultValue={searchParams.get('post_id') || ''} />}
      <input hidden name="last_resource_guid" defaultValue={cookies.last_resource_guid} />
      <StatusInputs
        name="unsubscribe"
        errorMessage={t('account_actions.downgrade.toast.error')}
        successMessage={t('account_actions.downgrade.toast.unsubscribed')}
      />
      <Button type="submit" variant="danger" isLoading={isSubmitting} btnSize="md">
        {isSubmitting ? `${t('shared.actions.unsubscribing')}…` : t('shared.cta.unsubscribe')}
      </Button>
    </fetcher.Form>
  );
};

export default Unsubscribe;
